/**
 * Admin hash routing: Labs regrouping aliases + optional Math Lab sections.
 *
 * Canonical hashes:
 *   #admin/resultsLab
 *   #admin/nlpLab
 *   #admin/mathLab            (defaults to calculator)
 *   #admin/mathLab/validate
 *   #admin/coverageLab
 *
 * Old System hashes still resolve so bookmarks and the trial guide keep working.
 */

export const ADMIN_TAB_ALIASES = {
  pipelineTrace: { tab: 'nlpLab' },
  mathCore: { tab: 'mathLab', section: 'calculator' },
  mathValidation: { tab: 'mathLab', section: 'validate' },
  api: { tab: 'coverageLab' },
};

export const MATH_LAB_SECTIONS = [
  'calculator',
  'sgp',
  'validate',
  'integrity',
  'howItWorks',
  'limits',
  'audit',
];

const MATH_SECTION_SET = new Set(MATH_LAB_SECTIONS);

export function parseAdminHash(hash) {
  const raw = String(hash || '').replace(/^#/, '').trim();
  if (!raw) return null;
  const parts = raw.split('/').filter(Boolean);
  if (parts[0] !== 'admin' || !parts[1]) return null;
  return { key: parts[1], rest: parts.slice(2) };
}

export function resolveAdminTab(hash) {
  const parsed = parseAdminHash(hash);
  if (!parsed) return null;

  const alias = ADMIN_TAB_ALIASES[parsed.key];
  const tab = alias?.tab || parsed.key;
  let section = alias?.section || parsed.rest[0] || null;

  if (tab === 'mathLab') {
    if (!section || !MATH_SECTION_SET.has(section)) section = 'calculator';
  } else {
    section = null;
  }

  return { tab, section };
}

export function adminHashFor(tab, section) {
  if (tab === 'mathLab' && section && MATH_SECTION_SET.has(section)) {
    return `#admin/mathLab/${section}`;
  }
  return `#admin/${tab}`;
}
